import React, { useEffect, useRef } from 'react';
import { shotAlt } from './ShotMeta';
import { site } from './data/site';

// Right-click and drag are blocked on gallery photos only. This is a deterrent for casual
// reuse, not protection: a screenshot or the network tab still yields the image.
const blockContextMenu = (event) => event.preventDefault();

const EXPECTED = {
  wide: '1600 x 900 px',
  tall: '1200 x 1600 px',
  normal: '1600 x 1200 px',
};

// The photo, or a labelled placeholder naming the expected file when it cannot load.
const ShotImage = ({ shot, failed, onFail, className = '' }) => {
  const imgRef = useRef(null);

  // An image can fail before React attaches onError (cached 404, server-rendered markup).
  useEffect(() => {
    const node = imgRef.current;
    if (node && node.complete && node.naturalWidth === 0) onFail(shot.src);
  }, [shot.src, onFail]);

  if (failed) {
    return (
      <span
        className={`shot-missing ${className}`}
        role="img"
        aria-label={`${shotAlt(shot)}. Photo file not found.`}
      >
        <span className="shot-missing-title">photo not found</span>
        <span>size {EXPECTED[shot.span] || EXPECTED.normal}</span>
      </span>
    );
  }

  // The watermark is a real overlay, not baked into the JPEG, so the original stays clean.
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- only swallows the context menu
    <span className="shot-frame" onContextMenu={blockContextMenu}>
      <img
        ref={imgRef}
        className={className}
        src={shot.src}
        alt={shotAlt(shot)}
        loading="lazy"
        decoding="async"
        draggable={false}
        onContextMenu={blockContextMenu}
        onError={() => onFail(shot.src)}
      />
      <span className="shot-mark" aria-hidden="true">
        {site.domain}
      </span>
    </span>
  );
};

export default ShotImage;
